import React from 'react'
import { Doughnut } from 'react-chartjs-2'

import { values } from 'object.values'

if (!Object.values) {
  values.shim()
}

export default class RSRLDoughnut extends React.Component {
  render() {
    // const feuil1 = this.props.data.allLettersXlsxFeuil1.edges
    // let labels = feuil1.map((row,i) => (row.node.letter))
    // let values = feuil1.map((row,i) => (row.node.value))
    let data = {
      labels: this.props.labels,
      datasets: [
        {
          data: this.props.values,
          backgroundColor: this.props.backgroundColor,
        },
      ],
    }
    let options = {
      maintainAspectRatio: false,
      legend: {
        position: 'bottom',
        labels: {
          fontSize: 16,
          boxWidth: 40,
          padding: 40,
        },
      },
      tooltips: {
        mode: 'index',
        axis: 'x',
        cornerRadius: 0,
        xPadding: 16,
        yPadding: 16,
        backgroundColor: '#707070',
      },
    }

    return (
      <div className="donut-wrapper">
        <div className="scroll-area">
          <Doughnut data={data} options={options} />
        </div>
      </div>
    )
  }
}
